import {
    VuexModule,
    Module,
    Mutation,
    Action,
    getModule
  } from "vuex-module-decorators";
  import { DeviceCount } from "@/types";
  import store from "@/store";
  import { getDevicesList } from '@/api/deviceCountService';
  import lodash from "lodash";
  
  export interface DeviceCountState {
    deviceList: DeviceCount[];
    loading: boolean;
  }
  
  @Module({ store, dynamic: true, name: "deviceCountModule" })
  class DeviceCountModule extends VuexModule implements  DeviceCountState{
    public deviceList: DeviceCount[] = [];
    public loading = false;
  
  
    @Action async deviceCountList() {
      this.setLoading(true);
      this.setdeviceCountList(await getDevicesList());
      this.setLoading(false);
    }
  
  
    @Mutation setLoading(loading: boolean): void {
      this.loading = loading;
    }
  
    @Mutation setdeviceCountList(deviceList: DeviceCount[]): void {
      this.deviceList = lodash.cloneDeep(deviceList);
    }
  }
  
  export const deviceCountModule = getModule(DeviceCountModule);
  